import { render, staticRenderFns } from "./InvoicePaymentReceiptForm.vue?vue&type=template&id=e4f435b0"
import script from "./InvoicePaymentReceiptForm.vue?vue&type=script&lang=js"
export * from "./InvoicePaymentReceiptForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports